import React, { Component } from "react";
import _ from "lodash";
import { Pagination } from "antd";
import queryString from "query-string";
import Fuse from "fuse.js";
import { withRouter } from "react-router-dom";
import { ProductItem, Spin } from "../../components";
import { withRedux } from "../../hoc";
import ProductContainer from "./Container";

const PAGE_SIZE = 24;

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages"),
    product: _.get(state, "product")
  };
};

const actions = {};

@withRouter
@withRedux(mapStateToProps, actions)
export default class Product extends Component {
  filterProducts = products => {
    let result = products;
    const { search } = this.props.location;
    if (_.isEmpty(search)) return products;
    const parsed = queryString.parse(search);
    const brand = _.toInteger(_.get(parsed, "brand"));
    const category = _.toInteger(_.get(parsed, "category"));
    const q = _.get(parsed, "q", "");
    if (brand) result = _.filter(result, { brand_id: brand });
    if (category) result = _.filter(result, { category_id: category });
    if (q) {
      const filterKey = ["name", "model"];
      const keys = filterKey;
      const languages = this.props.languages.data;
      _.map(filterKey, value => {
        _.map(languages, language => {
          keys.push(`${value}.${language.key}`);
        });
      });
      const options = {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys
      };
      const fuse = new Fuse(_.toArray(result), options);
      result = fuse.search(q);
    }
    return result;
  };
  getCurrentPage = () => {
    const { search } = this.props.location;
    const parsed = queryString.parse(search);
    const currentPage = _.toInteger(_.get(parsed, "page", 1));
    return currentPage;
  };
  getProducts = () => {
    const products = _.get(this.props, "product.products.data");
    const filterProducts = this.filterProducts(products);
    return filterProducts;
  };
  getProductsPagination = products => {
    const currentPage = this.getCurrentPage();
    const paginationProducts = _.slice(
      _.toArray(products),
      (currentPage - 1) * PAGE_SIZE,
      PAGE_SIZE * currentPage
    );
    return paginationProducts;
  };
  handleChangePagination = page => {
    const { search } = this.props.location;
    const parsed = queryString.parse(search);
    const brand = _.toInteger(_.get(parsed, "brand"));
    const category = _.toInteger(_.get(parsed, "category"));
    const q = _.get(parsed, "q", "");
    const params = {
      brand,
      category,
      q,
      page
    };
    const stringified = queryString.stringify(params);
    this.props.history.push({
      pathname: "/product",
      search: `?${stringified}`
    });
  };
  renderPagination = () => {
    const currentPage = this.getCurrentPage();
    const products = this.getProducts();
    const productCount = _.size(products);
    return (
      <Pagination
        current={currentPage}
        defaultPageSize={PAGE_SIZE}
        total={productCount}
        onChange={this.handleChangePagination}
      />
    );
  };
  renderProductList = () => {
    let products = this.getProducts();
    products = this.getProductsPagination(products);
    return (
      <div className="products-block">
        <div className="pagination-top">{this.renderPagination()}</div>
        <div className="product-list">
          <div className="row">
            {_.map(products, (product, key) => {
              const brand = _.find(this.props.product.brands.data, {
                id: _.get(product, "brand.id")
              });
              return (
                <div key={key} className="col-md-6 col-lg-4">
                  <ProductItem.Grid {...product} brand={brand} />
                </div>
              );
            })}
          </div>
        </div>
        <div className="pagination-bottom">{this.renderPagination()}</div>
      </div>
    );
  };
  render() {
    const { t } = this.props;
    const products = this.getProducts();
    const productCount = _.size(products);
    const productsLoading = _.get(this.props, "product.products.loading");
    const productsFetched = _.get(this.props, "product.products.fetched");
    return (
      <ProductContainer>
        <Spin spinning={productsLoading}>
          <div className="products-result">
            {productCount === 0 && productsFetched ? (
              <div className="empty-products" style={{ padding: 15 }}>
                {t("Product Not found")}
              </div>
            ) : (
              this.renderProductList()
            )}
          </div>
        </Spin>
      </ProductContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Product/Product.js